// @flow
import React from "react";
import Transfers from "../../../svg/facilities/has_transfers.svg";
import "./transfersIcon.scss";

const TransfersIcon = () => <Transfers className="c-transfers-icon" />;

export default TransfersIcon;
